module.exports = __webpack_public_path__ + "img/bg_avatar_female_05.12df7b26.png";